import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { NotFoundComponent } from './not-found.component';

@NgModule({
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ShimanoPageBackGroundComponent: {
          component: NotFoundComponent,
        },
      },
    } as CmsConfig),
    NotFoundComponent,
  ],
  providers: [{ provide: NotFoundComponent }],
})
export class NotFoundModule {}
